"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/resolve-styles/resolve-styles.ts
function resolveStyles({ theme, styles, props, stylesCtx }) {
	const arrayStyles = Array.isArray(styles) ? styles : [styles];
	const result = {};
	for (const style of arrayStyles) if (typeof style === "function") Object.assign(result, style(theme, props, stylesCtx));
	else if (style) Object.assign(result, style);
	return result;
}
//#endregion
export { resolveStyles };

//# sourceMappingURL=resolve-styles.mjs.map